<div #profilePhotoModalReactWrapperComponent></div>